import { $, $$ } from '@utils';

function init() {
  if (!$('[data-au-file-upload]')) return;

  addEventListener();
}

function addEventListener() {
  const dropZone = $$('[data-au-drop-zone]');
  const fileInput = $$('[data-au-file-upload]');

  // Delegated remove handler: covers both static (fileKo) and dynamic items
  $$('[data-au-file-upload-parent]').forEach((parent) => {
    parent.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('.au-file-upload__remove');
      if (!removeBtn) return;

      const fileItem = removeBtn.closest('[data-au-file-upload-item], .au-file-upload__item-wrapper');
      if (!fileItem) return;

      const filesList = fileItem.closest('[data-au-files-list]');
      const remainingItems = filesList.querySelectorAll('[data-au-file-upload-item], .au-file-upload__item-wrapper');

      if (remainingItems.length <= 1) {
        const input = parent.querySelector('[data-au-file-upload]');
        if (input) input.value = '';
        filesList.hidden = true;
      }

      fileItem.remove();

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickUpload',
        item_id: 'upload file_borrar',
      });
    });
  });

  // Drag and drop events
  dropZone.forEach((dropZ) => {
    dropZ.addEventListener('dragover', (e) => {
      e.preventDefault();
      dropZ.classList.add('au-file-upload__drop-zone--dragover');
    });

    dropZ.addEventListener('dragleave', () => {
      dropZ.classList.remove('au-file-upload__drop-zone--dragover');
    });

    dropZ.addEventListener('drop', (e) => {
      e.preventDefault();
      const input = dropZ.querySelector('[data-au-file-upload]');
      dropZ.classList.remove('au-file-upload__drop-zone--dragover');

      handleFiles(e.dataTransfer.files, input);
      input.files = e.dataTransfer.files;

      input.focus();
      input.blur();
    });

    // Click to upload
    dropZ.addEventListener('click', () => {
      dropZ.querySelector('[data-au-file-upload]').click();
    });
  });

  // Handle inputs file change
  fileInput.forEach((input) => {
    input.addEventListener('change', () => {
      handleFiles(input.files, input);
    });
  });
}

// Helper to create file list item
function createFileItem(file, spinnerSrc) {
  const fileItem = document.createElement('div');
  fileItem.className = 'au-file-upload__item t-detail';
  fileItem.setAttribute('data-au-file-upload-item', '');

  const fileItemImg = document.createElement('div');
  fileItemImg.className = 'au-file-upload__item-img';

  const spinner = document.createElement('img');
  spinner.className = 'au-file-upload__spinner';
  if (spinnerSrc) spinner.src = spinnerSrc;

  const itemIcon = document.createElement('span');
  itemIcon.className = 'au-file-upload__check material-symbols-rounded';
  itemIcon.setAttribute('aria-hidden', 'true');
  itemIcon.setAttribute('data-au-icon', '');
  itemIcon.textContent = 'check';

  fileItemImg.appendChild(spinner);

  const fileName = document.createElement('div');
  fileName.className = 'au-file-upload__file-name';
  fileName.textContent = file.name;

  const removeButton = document.createElement('button');
  removeButton.className = 'au-file-upload__remove';

  const removeIcon = document.createElement('span');
  removeIcon.className = 'material-symbols-rounded';
  removeIcon.setAttribute('aria-hidden', 'true');
  removeIcon.setAttribute('data-au-icon', '');
  removeIcon.textContent = 'close';

  removeButton.appendChild(removeIcon);

  fileItem.appendChild(fileItemImg);
  fileItem.appendChild(fileName);
  fileItem.appendChild(removeButton);

  // Simulate file upload delay
  setTimeout(() => {
    fileItemImg.removeChild(spinner);
    fileItemImg.appendChild(itemIcon);
    removeIcon.textContent = 'delete';
  }, 2000);

  return fileItem;
}

// Handle file input
function handleFiles(files, input) {
  const parent = input.closest('[data-au-file-upload-parent]');
  const filesList = parent.querySelector('[data-au-files-list]');
  const spinnerSrc = parent.dataset.auFileUploadSpinner;
  filesList.hidden = false;
  Array.from(files).forEach((file) => {
    const fileItem = createFileItem(file, spinnerSrc);
    filesList.appendChild(fileItem);
  });

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickUpload',
    item_id: 'upload file_ok',
  });
}

export default { init };
